import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ConfirmedFilled } from '@one-thd/sui-icons';
import {
  Typography
} from '@one-thd/sui-atomic-components';
import { findMatchingRefinementInDimension } from '../../utils/fulfillment-helpers';

const FulfillmentTypeSelector = ({
  selectedFulfillment,
  handleChange,
  fulfillmentDimensions
}) => {
  const fulfillmentRefinements = fulfillmentDimensions[0]?.refinements || [];
  const filteredRefinements = fulfillmentRefinements.filter((refinement) => refinement.label !== 'Free Delivery');

  return (
    <div className="sui-rounded-lg sui-p-1 sui-flex sui-bg-brand-subtle">
      {filteredRefinements.map((option) => {
        const isSelected = /delivery/i.test(selectedFulfillment)
          ? /delivery/i.test(option.label) : option.label === selectedFulfillment;

        const buttonClassName = classNames(
          'sui-rounded-lg',
          'sui-p-1',
          'sui-flex',
          'sui-items-center',
          'sui-justify-center',
          'sui-gap-1',
          'sui-flex-1',
          {
            'sui-bg-primary': isSelected
          }
        );
        let matchedRefinement;
        let matchedDimension;

        if (filteredRefinements.length > 1) {
          const match = findMatchingRefinementInDimension(
            fulfillmentDimensions[0], option.refinementKey
          );

          const { refinement, dimension } = match;

          matchedRefinement = refinement || option;
          matchedDimension = dimension || fulfillmentDimensions[0];
        } else {
          matchedRefinement = option;
          matchedDimension = fulfillmentDimensions[0];
        }

        return (
          <button
            key={option.label}
            onClick={() => handleChange({ refinement: matchedRefinement, dimension: matchedDimension })}
            className={buttonClassName}
            type="button"
            aria-pressed={isSelected}
            data-testid={`fulfillment-option-${option.label}`}
          >
            <Typography weight={isSelected ? 'bold' : 'regular'}>
              {option.label}
            </Typography>
            {isSelected && (
              <ConfirmedFilled
                size="small"
                data-testid={`checkmark-${option.label}`}
              />
            )}
          </button>
        );
      })}
    </div>
  );
};

FulfillmentTypeSelector.propTypes = {
  selectedFulfillment: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  fulfillmentDimensions: PropTypes.arrayOf(PropTypes.shape({
    dimensionId: PropTypes.string,
    label: PropTypes.string,
    refinements: PropTypes.arrayOf(
      PropTypes.shape({})
    )
  })).isRequired
};

FulfillmentTypeSelector.displayName = 'FulfillmentTypeSelector';

export { FulfillmentTypeSelector };